import { Col, Row } from "antd";
import React from "react";
import PageTitle from "../header/pageTitle";

function StyledContentCard({
  title,
  subTitle,
  showSearch,
  children,
  showEdit,
  onClickEdit,
}) {
  return (
    <Row className="w-full" align={"middle"} justify={"center"}>
      <Col span={24} className="content-card">
        {(title || subTitle || showSearch) && (
          <Col className="content-card-header">
            <PageTitle
              title={title}
              subTitle={subTitle}
              showSearch={showSearch}
              showEdit={showEdit}
              onEdit={onClickEdit}
            />
          </Col>
        )}
        <Col className="content-card-body">{children}</Col>
      </Col>
    </Row>
  );
}

export default StyledContentCard;
